module.exports = __webpack_public_path__ + "media/images/invalid-request-fd2d58c3b7c886bd5cdcee047ade8cd5.svg";